import { render, staticRenderFns } from "./bookManagerOrg.vue?vue&type=template&id=51d07564&scoped=true&"
import script from "./bookManagerOrg.vue?vue&type=script&lang=js&"
export * from "./bookManagerOrg.vue?vue&type=script&lang=js&"
import style0 from "./bookManagerOrg.vue?vue&type=style&index=0&id=51d07564&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d07564",
  null
  
)

export default component.exports